export enum PrimarySupportArea {
  COMMUNICATION = "COMMUNICATION",
  SEVERE_BEHAVIOR = "SEVERE_BEHAVIOR",
  MINOR_BEHAVIOR_CONCERNS = "MINOR_BEHAVIOR_CONCERNS",
  SOCIAL_SKILLS = "SOCIAL_SKILLS",
  UNKNOWN = "UNKNOWN",
} 